import { cacheExchange } from '@urql/exchange-graphcache';
import { relayPagination } from '@urql/exchange-graphcache/extras';
import schema from 'gql-schema.min.json';

import { insightMutationUpdates } from './cache/insightUpdates';
import { keys } from './cache/keys';
import { noteMutationUpdates, noteSubscriptionUpdates } from './cache/noteUpdates';
import { shareMutationUpdates } from './cache/shareUpdates';
import { taskResultGlobalIds } from './cache/taskResultGlobalIds';
import { taskResultMutationUpdates } from './cache/taskResultUpdates';

export const urqlCacheExchange = cacheExchange({
  // Schema-aware mode: deterministic partial results, interface/union fragment
  // matching, and dev "Invalid key" warnings. Minified form of the same
  // introspection gql.tada generates from.
  schema,
  keys,
  globalIDs: taskResultGlobalIds,
  resolvers: {
    Query: {
      insights: relayPagination(),
    },
  },
  updates: {
    Mutation: {
      ...noteMutationUpdates,
      ...shareMutationUpdates,
      ...insightMutationUpdates,
      ...taskResultMutationUpdates,
    },
    Subscription: {
      ...noteSubscriptionUpdates,
    },
  },
});
